/*
 * @Author: 哎呦先生 392632962@qq.com
 * @Date: 2024-01-23 10:49:01
 * @LastEditors: 哎呦先生 392632962@qq.com
 * @LastEditTime: 2024-03-07 11:48:20
 * @FilePath: \官网\src\compoment\job.jsx
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import React from 'react';
import TweenOne from 'rc-tween-one';
import { Collapse, List, Image } from 'antd';
import { enquireScreen } from 'enquire-js';
import { CaretRightOutlined } from '@ant-design/icons';
import { Descriptions } from 'antd';
const { Panel } = Collapse;

let isMobile;
enquireScreen((b) => {
    isMobile = b;
    // console.log(isMobile);
});


class jobItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,

        };
    }


    componentDidMount () {

        const urlParams = new URL(window.location.href);
        enquireScreen((b) => {
            this.setState({ isMobile: b });

        });




    }

    toPdf = (url) => {
        const w = window.open('about:blank');
        w.location.href = url
    }

    getheader = (item) => {
        // console.log(2222, item)
        return <>
            <Descriptions title={item.jobName}>
                <Descriptions.Item label="招聘单位">{item.head.unit}</Descriptions.Item>
                <Descriptions.Item label="招聘人数">{item.head.limit}</Descriptions.Item>
                <Descriptions.Item label="工作地点">{item.head.city}</Descriptions.Item>
                <Descriptions.Item label="发布日期">{item.head.date}</Descriptions.Item>
                <Descriptions.Item label="投递邮箱">
                    {item.head.email}
                </Descriptions.Item>
                <Descriptions.Item label="有效日期">
                    永久
                </Descriptions.Item>
            </Descriptions>

        </>
    }
    getContext (item) {

        return <div style={{ display: this.state.isMobile ? 'block' : 'flex' }}>
            <List
                // bordered
                split={false}
                size="small"
                header='岗位职责'
                dataSource={item.jobdesc}
                style={{ flex: '1 1 50%', color: 'black', marginRight: '50px' }}
                renderItem={(item) => (
                    <List.Item >
                        {item}
                    </List.Item>
                )}
            />
            <List
                // bordered
                split={false}
                size="small"
                header='任职要求'
                dataSource={item.jobask}
                style={{ flex: '1 1 50%' }}
                renderItem={(item) => (
                    <List.Item>
                        {item}
                    </List.Item>
                )}
            />
        </div>
    }
    render () {
        let children = <Collapse
            bordered={false}
            // defaultActiveKey={['1']}
            //F4F5F7
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} style={{ color: '#05933c', fontSize: '14px' }} />}
            style={{ backgroundColor: '#F4F5F7' }}
            expandIconPosition='end'
        >
            {
                this.props.data.map((item, index) => {
                    return <Panel header={this.getheader(item)} key={index} style={{ marginTop: '20px', backgroundColor: '#ffffff' }} >
                        {this.getContext(item)}
                    </Panel>
                })
            }

        </Collapse>
        return (

            <div style={this.props.style}>
                {children}
            </div>


        );
    }
}

export default jobItem;
